import { Injectable } from '@angular/core';
import { TrackingService } from './tracking.service';
import { ITrackingEventGtm } from '../models/tracking/tracking-event.model';
import { Queue } from '../models/queue.model';

@Injectable({
    providedIn: 'root',
})
export class GtmService extends TrackingService {
    private _eventQueue = new Queue<ITrackingEventGtm>();

    track(e: ITrackingEventGtm): void {
        if (!this.Window) {
            return;
        }

        if (this.Window.top && this.Window.self !== this.Window.top) {
            this.Window.top.postMessage({ tracking: e }, '*');

            return;
        }

        this.addToDataLayer(e);
    }

    private addToDataLayer(e: ITrackingEventGtm): void {
        if (!this.hasConsent) {
            this._eventQueue.enqueue(e);

            return;
        }

        this.Window?.dataLayer.push(e);
    }

    override processQueue(): void {
        while (!this._eventQueue.isEmpty()) {
            const event = this._eventQueue.dequeue();

            if (event) {
                this.addToDataLayer(event);
            }
        }
    }
}
